<template>
  <div class="solution">
    <div class="banner">
      <div class="title">家居行业解决方案</div>
      <div class="desc">
        <section>为家居行业搭建统一的内容数字化中台，连接现有系统，结构化细分品牌，</section>
        <section>统一管理、统一标准、统一赋能，助力家居行业业务增长</section>
      </div> 
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>    
            <section>家居行业经营模式层级多：国内各大区市场、海外各区域市场、直营店、加盟商、经销</section>
            <section>商、TO B业务线、TO C业务线等，导致权限细分，管理难度大；品牌繁杂，地域、层</section>
            <section>级多样，内容统一管理难</section>
            <section class='title purple'>解决方案</section>
          <section><span class="marginTop">内容资产构建：</span>建立企业内容中台，营销内容数字化沉淀管理，包括企业自有素材、内</section>
            <section>容代理创作素材、UGC创作素材等，整合内容资产构建，提高内容复用率</section>
            <section><span>精细化内容管理：</span>分层管理，颗粒化权限控制，杜绝管理漏洞。通过内容、人、组织三</section>
            <section>个维度的颗粒化权限控制，实现内容和管理的精细化</section>
            <section class="point">• 内容权限：内容的修改、移动、分享、时效、锁定等控制维度，实现内容精细化管理</section>
            <section class="point">• 人员权限：每个角色/职位的功能支持50多项精细化配置</section>
            <section class="point">• 组织权限：对于多个分支机构或多品牌企业，做内容隔离和共享</section>
          </div>
        </div>
        <img class="img" src="https://dam-static.isheji.com/qiye1.0/solution/house/2.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://dam-static.isheji.com/qiye1.0/solution/house/3.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>商品SKU多，包括：整装、零售、场景定制、卫阳、厨房、木门墙板、家配软装等，</section>
            <section>SKU更新迭代快，版本多，数量大，传输方式单一，内容共享效率低</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">内容标签体系：</span>创建统一的品牌标签体系，多维度内容标签管理，提升内容查找、共享</section>
            <section>和分发效率</section>
            <section class="point">• 智能标签：利用AI智能提取如文件格式、色彩、场景、logo、公众人物、地点、文字</section>
            <section>等关键词</section>
            <section class="point">• 产品标签：智能提取品牌SKU、型号等其他更细致的特征信息</section>
            <section class="point">• 营销标签：将智能标签能力提取的信息与行业洞察标签体系融合，建立更科学的标签</section>
            <section>体系</section>
            <section class="point">• 管理标签：根据管理需求，对内容的使用和限制进行的管理标签</section>
            <section><span>智能内容搜索：</span>通过关键词搜索（文件名、分类标签、智能标签等）+条件检索（文件</section>
            <section>类型、日期等）+分类检索（图⽚、视频、⾳频等），让目标内容无处可藏</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
             <div class="idesc">
            <section class='title'>痛点</section>
            <section>总店/区域/门店，加盟商/经销商、市场人员、基础一线业务员等人员内容生产水平参</section>
            <section>差不齐，一线营销内容少，自行制作难度大，品牌不一致问题频发</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">AIGC智能工具：</span>AI智能生成文案，赋能一线营销人员；在线设计，拖拉拽傻⽠式操作，</section>
            <section>⾼效操作，产出符合品牌规范的设计；智能写作、模板编辑、H5创作、智能延展、批量</section>
            <section>抠图、批量套版等AI智创工具，快速产出创意物料，辅助营销</section>
            <section><span>品牌规范管理：</span>设计师将企业品牌设计规范数字化/在线化，通过内容权限锁定功能，</section>
            <section>使物料调整范围约束在品牌要求内，确保修改内容的物料符合品牌规范</section>
            <section><span>品牌合规管理：</span>智能审核内容的合规性：涉⻩涉暴涉政涉恐内容智能检测；智能⼴告法</section>
            <section>合规检测；名⼈肖像权智能检测，肖像权时效设定；版权素材时效性设定；内容素材有</section>
            <section>效期设定确保保密期的物料不被泄露等，保障品牌合规性</section>
          </div>
        </div>
        <img class="img" src="https://dam-static.isheji.com/qiye1.0/solution/house/4.png">

      </div>
        <div class="row drak">
        <img class="img" src="https://dam-static.isheji.com/qiye1.0/solution/house/5.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>家居行业营销平台多，营销层级多，营销人员多，无法连接全部内容系统/平台，内容</section>
            <section>分发效率低下，全员内容营销难把控</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">社交媒体内容一键分发：</span></section>
            <section>社交媒体账号授权后，将内容中台的图片、视频一键分发到平台账号；内容分发后的效</section>
            <section>果数据平台自动回流，掌控各个平台的内容表现数据</section>
            <section><span>营销内容全员分发：</span></section>
            <section>全员营销定向任务分发，添加营销物料（图片、视频、可编辑的模板等），任务执行方接</section>
            <section>收任务并进行相关操作，跟进监控完成情况数据，提升各层级人员内容流转效率及质量</section>
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'network',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://dam-static.isheji.com/qiye1.0/solution/house/1.png');
      width: 100%;
      min-width: 1400px;
      background-size: cover;
      height: 460px;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }
     
    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                padding-left: 16px;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                }
            }
            .point {
              margin-top: 8px;
            }
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>